import { render, staticRenderFns } from "./Modex2026.vue?vue&type=template&id=2db83fd0&"
import script from "./Modex2026.vue?vue&type=script&lang=js&"
export * from "./Modex2026.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports